import React, { Component } from 'react';
import PropTypes from 'prop-types';


class ArraRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { value } = this.props;
    const sortedValues = (value || []).sort();
    return <>{sortedValues.join(', ')}</>;
  }
}

ArraRenderer.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
};
ArraRenderer.defaultProps = {
  value: null,
};


export default ArraRenderer;
